/* eslint-disable react/require-default-props */
import React, { FC } from 'react';
import classNames from 'classnames';
import { Form } from 'react-bootstrap';

import './FormCheckbox.scss';

export interface IProps {
  id: string;
  label?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  checked: boolean;
  error?: string;
  disabled?: boolean;
  focus?: boolean;
  className?: string;
}

export const FormCheckbox: FC<IProps> = ({
  id,
  label,
  onChange,
  checked,
  error,
  disabled,
  focus,
  className,
}: IProps) => (
  <Form.Group className={classNames('PraktioFormCheckbox', className, { disabled })}>
    <Form.Check custom type="checkbox" id={id}>
      <Form.Check.Input
        autoFocus={focus}
        type="checkbox"
        isInvalid={!!error}
        checked={checked}
        disabled={disabled}
        onChange={disabled ? undefined : onChange}
      />
      {!!label && <Form.Check.Label>{label}</Form.Check.Label>}
      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    </Form.Check>
  </Form.Group>
);

export default FormCheckbox;
